






































































import GetAuthTokenMutation from '@/graphql/mutations/getAuthToken.gql';
import GetFileCookiesQuery from '@/graphql/queries/getFileCookies.gql';
import CreateUserMutation from '@/graphql/mutations/createUser.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SignUp extends Vue {
  public username: string = '';
  public email: string = '';
  public password: string = '';
  public errorMessage: string = '';

  public show() {
    this.errorMessage = '';
    this.username = '';
    this.email = '';
    this.password = '';
  }

  get submitClass() {
    return {
      dim: this.username && this.email && this.password,
    };
  }

  public attemptCreateUser() {
    this.errorMessage = '';

    const username = this.username;
    const email = this.email;
    const password = this.password;

    request(CreateUserMutation as any, { username, email, password })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw Error(errors[0].message);
        }
      })
      .then(() => {
        request(GetAuthTokenMutation as any, { username, password })
          .then(({ data }) => {
            const token = data && data.getAuthToken;
            if (token) {
              this.$store.dispatch('auth/setAuthToken', token);
              request(GetFileCookiesQuery as any, {}).then(
                (fileData: { data: any }) => {
                  const {
                    keyPairId,
                    policy,
                    signature,
                  } = fileData.data.getFileCookies;
                  this.$store.dispatch(
                    'auth/setFileQueryParams',
                    `Key-Pair-Id=${keyPairId}&Policy=${policy}&Signature=${signature}`
                  );
                  this.$router.push('/manageDevices');
                }
              );
            } else {
              throw Error('Account creation failed');
            }
          })
          .catch(error => {
            this.errorMessage = error.message;
          });
      })
      .catch(error => {
        this.errorMessage = error.message;
      });
  }
}
